import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import HiddenField from 'main/components/user/apikey/HiddenField';
import Utils from 'utils/Utils';

import useStyles from './styles';

const SPACE = ' ';

const KeysList = ({ onSelect, selected, apiKeys }) => {
    const { classes, cx } = useStyles();

    const handleRowClick = useCallback((apiKey) => () => onSelect && onSelect(apiKey), [onSelect]);

    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell width={130}>{'Creation Date'}</TableCell>
                        <TableCell>{'Name'}</TableCell>
                        <TableCell>{'API Key'}</TableCell>
                        <TableCell>{'Scope'}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {apiKeys.map((item) => (
                        <TableRow
                            key={item.id}
                            className={cx(classes.selectable, {
                                [classes.selected]: item.id === selected.id
                            })}
                            onClick={handleRowClick(item)}
                        >
                            <TableCell>{Utils.formatDateT(item.published)}</TableCell>
                            <TableCell>{item.name}</TableCell>
                            <TableCell>{<HiddenField text={item.id} />}</TableCell>
                            <TableCell>{item.scope.join(SPACE)}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

KeysList.propTypes = {
    apiKeys: PropTypes.array,
    selected: PropTypes.object,
    onSelect: PropTypes.func
};

KeysList.defaultProps = {
    apiKeys: []
};

export default KeysList;
